/* jshint ignore:start */
'use strict';

(function (window, document) {

	var fullpageElement = document.querySelector('#fullpage');
	if (!fullpageElement) {
		return;
	}

	var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

	function preventDefault(e) {
		e.preventDefault();
	}

	function preventDefaultForScrollKeys(e) {
		if (keys[e.keyCode]) {
			preventDefault(e);
			return false;
		}
	}

	// modern Chrome requires { passive: false } when adding event
	var supportsPassive = false;
	try {
		window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
			get: function () { supportsPassive = true; }
		}));
	} catch (e) { }

	var wheelOpt = supportsPassive ? { passive: false } : false;
	var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

	// call this to Disable
	function disableScroll() {
		window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
		window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
		window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
		window.addEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	// call this to Enable
	function enableScroll() {
		window.removeEventListener('DOMMouseScroll', preventDefault, false);
		window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
		window.removeEventListener('touchmove', preventDefault, wheelOpt);
		window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	var sections = fullpageElement.querySelectorAll('.section');
	var nextSectionArrows = fullpageElement.querySelectorAll('.next-section');
	var menuItems = fullpageElement.querySelectorAll('.fullpage-menu span');
	var maxSection = sections.length - 1;
	var currentSection = 0;
	var lastScroll = 0;
	var scrollEventet = null;
	var disableScrollEvent = false;
	var resizeTimer = null;
	var enableScrollTimer = null;

	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			updateHeight();
		}, 100);
	});

	function updateHeight() {
		for (var index = 0; index < sections.length; index++) {
			sections[index].style.height = (window.innerHeight - 85) + 'px';
		}
	}

	function isInViewport(el) {
		var rect = el.getBoundingClientRect();
		return (rect.top >= -20 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth));
	}

	function getElementY(element) {
		return window.pageYOffset + element.getBoundingClientRect().top;
	}

	function doScrolling(element, duration) {
		var startingY = window.pageYOffset;
		var elementY = getElementY(element);

		var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight - 85 : elementY - 85;
		var diff = targetY - startingY;

		var easing = function (t) {
			return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
		};
		var start;

		if (!diff) {
			return;
		}

		window.requestAnimationFrame(function step(timestamp) {

			var reelementY = getElementY(element);
			var retargetY = document.body.scrollHeight - reelementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight - 85 : reelementY - 85;
			var rediff = retargetY - startingY;

			if (diff !== rediff) {
				diff = rediff;
			}

			if (!start) {
				start = timestamp;
			}
			var time = timestamp - start;
			var percent = Math.min(time / duration, 1);
			percent = easing(percent);
			window.scrollTo(0, startingY + diff * percent);
			if (time < duration) {
				window.requestAnimationFrame(step);
			} else {
				setTimeout(function () {
					disableScrollEvent = false;
					element.classList.add('come-in');
					setMenuItem();
					//setTimeout(function () {
					//  enableScroll();
					//}, 500);
				}, 100);
			}
		});
	}

	function scrollToNext(direction) {
		disableScrollEvent = true;
		var top = 0;
		if (direction === 'up' && currentSection !== 0) {
			currentSection -= 1;
		}

		if (direction === 'down' && currentSection < maxSection) {
			currentSection += 1;
		}

		doScrolling(document.querySelectorAll('.section')[currentSection], 500);
	}

	function setMenuItem() { // jshint ignore:line
		if (menuItems.length === 0) {
			return;
		}

		for (var index = 0; index < menuItems.length; index++) {
			var element = menuItems[index];
			element.classList.remove('active');
			if (index === currentSection) {
				element.classList.add('active');
			}
		}
	}

	function getNearest() {
		var nearest = null;
		var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
		for (var index = 0; index < sections.length; index++) {
			var dist = Math.abs(scrollTop - getElementY(sections[index]));
			if (!nearest) {
				nearest = [dist, index];
			}
			if (dist <= nearest[0]) {
				nearest = [dist, index];
			}
		}

		currentSection = nearest[1];
		document.querySelectorAll('.section')[currentSection].classList.add('come-in');
		setMenuItem();
	}

	window.addEventListener('scroll', function (ev) {
		clearTimeout(enableScrollTimer);
		var st = window.pageYOffset || document.documentElement.scrollTop;
		var direction = '';

		enableScrollTimer = setTimeout(function () {
			enableScroll();
		}, 500);

		if (st > lastScroll) {
			direction = 'down';
		}
		if (st < lastScroll) {
			direction = 'up';
		}

		lastScroll = st <= 0 ? 0 : st;

		if (disableScrollEvent) {
			ev.preventDefault();
			ev.stopPropagation();
			disableScroll();
			return;
		}

		if (direction === '') {
			disableScrollEvent = false;
			return;
		}

		if (direction === 'down' && currentSection === maxSection) {
			disableScrollEvent = false;
			return;
		}
		if (direction === 'up' && currentSection === maxSection && getElementY(sections[maxSection]) < lastScroll) {
			disableScrollEvent = false;
			return;
		}

		for (var ind = 0; ind <= maxSection; ind += 1) {
			if (isInViewport(sections[ind])) {
				currentSection = ind;
			}
		}

		// Just in case
		disableScrollEvent = true;
		disableScroll();

		scrollEventet = setTimeout(function () {
			scrollToNext(direction);
		}, 100);
	});

	for (var nsi = 0; nsi < nextSectionArrows.length; nsi++) {
		var arrowElement = nextSectionArrows[nsi];
		arrowElement.addEventListener('click', function () { // jshint ignore:line
			scrollToNext('down');
		});
	}

	for (var mii = 0; mii < menuItems.length; mii++) {
		var menuElement = menuItems[mii];
		menuElement.addEventListener('click', function () { // jshint ignore:line
			disableScrollEvent = true;
			currentSection = parseInt(this.getAttribute('data-section'), 10);
			doScrolling(document.querySelectorAll('.section')[currentSection], 500);
		});
	}

	getNearest();
	updateHeight();

})(window, document);
